import { render } from "./AreaEvolutionChart.vue?vue&type=template&id=224f1650&scoped=true"
import script from "./AreaEvolutionChart.vue?vue&type=script&lang=js"
export * from "./AreaEvolutionChart.vue?vue&type=script&lang=js"

import "./AreaEvolutionChart.vue?vue&type=style&index=0&id=224f1650&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-224f1650"]])

export default __exports__